const versionEnumToString = (versionEnum) => {
    switch (versionEnum) {
        case 0:
            return "Starter";
        case 1:
            return "Pro";
        case 2:
            return "Genius";
        default:
            return "Unknown";
    }
};

export const versionStringToEnum = (versionString) => {
    switch (versionString) {
        case "Starter":
            return 0;
        case "Pro":
            return 1;
        case "Genius":
            return 2;
        default:
            return -1;
    }
};

export const transformModules = (apiModules) => {
    if (!apiModules || !Array.isArray(apiModules)) return [];
    return apiModules.map((module) => ({
        id: module.moduleId,
        name: module.name,
        description: module.description,
        versions: (module.FGModuleVersions || []).map((version) => ({
            id: version.moduleVersionId,
            moduleId: version.moduleId,
            version: versionEnumToString(version.version),
            description: version.description,
            monthlyPrice: parseFloat(version.monthlyPrice),
            features: (version.FGModuleFeatureAssignments || []).map((assignment) => ({
                id: assignment.FGFeatures.featureId,
                name: assignment.FGFeatures.name,
                description: assignment.FGFeatures.description,
            })),
        })),
    }));
};

export const transformFeatures = (apiFeatures) => {
    if (!apiFeatures || !Array.isArray(apiFeatures)) return [];
    return apiFeatures.map((feature) => ({
        id: feature.featureId,
        name: feature.name,
        description: feature.description,
    }));
};

export const transformCustomerPrices = (apiResponse) => {
    if (!apiResponse || !apiResponse.customerPrices || !Array.isArray(apiResponse.customerPrices.items)) {
        return { total: 0, items: [] };
    }
    return {
        ...apiResponse.customerPrices,
        items: apiResponse.customerPrices.items.map((item) => ({
            ...item,
            monthlyPrice: parseFloat(item.monthlyPrice),
        })),
    };
};
